import styled from "styled-components";
import { media, mediumParagraph } from "@nested/brand";

const StyledP = styled.p`
  ${mediumParagraph}
`;

const A = styled.a`
  ${mediumParagraph}
`;

const FloatingCta = styled.div`
  display: none;
  z-index: 99999;

  ${media.tablet`
    text-align: center;
    display: block;
    position: fixed;
    bottom: 50px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 4px 8px 0 rgba(34, 34, 34, 0.1);
    padding: 20px;
    right: 35px;

    p:first-child {
      font-weight: bold;
    }

    p:last-child {
      text-align: center;
      margin-top: 10px;
      margin-bottom: 0;
    }
  `};
`;

export const FloatingEnquiryBox = () => (
  <FloatingCta>
    <StyledP>Interested in this property?</StyledP>
    <StyledP>
      Call us on <A href="tel:+442038580695">020 3858 0695</A>
    </StyledP>
  </FloatingCta>
);
